import type { BrokerListProps } from './InvestRepository.types';
import type { ParseCookiesContext } from '@/utils/cookies';
import type { AxiosInstance } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export class InvestRepository {
  private readonly api: AxiosInstance;

  constructor(ctx?: ParseCookiesContext) {
    this.api = setupApiClient(ctx);
  }

  listBrokers = async (): Promise<BrokerListProps[]> => {
    const { data } = await this.api.get<BrokerListProps[]>(
      apiConfig.routes.invest.brokers
    );
    return data;
  };
}

export const useGetListBrokers = (repo: InvestRepository) =>
  useQuery({
    queryKey: ['brokers'],
    queryFn: () => repo.listBrokers(),
  });
